import { render, staticRenderFns } from "./VxMultiSearchBar.vue?vue&type=template&id=b0ae41c0&scoped=true"
import script from "./VxMultiSearchBar.vue?vue&type=script&lang=js"
export * from "./VxMultiSearchBar.vue?vue&type=script&lang=js"
import style0 from "./VxMultiSearchBar.vue?vue&type=style&index=0&id=b0ae41c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0ae41c0",
  null
  
)

export default component.exports